var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCcOn = function SvgCcOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.193 22c-3.182 0-5.356-2.417-5.356-6 0-3.6 2.209-6 5.46-6 2.714 0 4.627 1.409 5.131 4.278H25.15C24.785 12.643 23.776 12 22.28 12c-1.965 0-3.148 1.478-3.148 3.913v.174c0 2.452 1.166 3.913 3.113 3.913 1.583 0 2.627-.678 2.94-2.452h2.278C27.028 20.574 25.01 22 22.193 22ZM9.894 22c-3.183 0-5.357-2.417-5.357-6 0-3.6 2.209-6 5.461-6 2.713 0 4.626 1.409 5.13 4.278H12.85C12.485 12.643 11.476 12 9.98 12c-1.965 0-3.147 1.478-3.147 3.913v.174C6.833 18.539 7.998 20 9.946 20c1.582 0 2.626-.678 2.94-2.452h2.277C14.73 20.574 12.711 22 9.893 22Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.5,
    d: "M4 25.25h24"
  })));
};
export default SvgCcOn;